import {ApiStatusCodeVo} from '../../../common/shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';

export const EVENT_END_MESSAGE =
  '죄송합니다. 이벤트가 마감되었습니다.\n다음 이벤트를 기대해주세요!';
export const MESSAGE_UNSUPPORTED_BROWSER = '지원하지 않는 브라우져입니다';
export const API_EVENT_PATH = '/api/v1/store/event/web';

/**
 * 트래킹에 쓰이는 서비스 키. 환경 상관 없이 유니크하게 사용됨
 */
export const SERVICE_DOMAIN = 'page.kakao.com';
export const FAVICON_ELEMENT =
  '<link rel="shortcut icon" href="https://page.kakaocdn.net/pageweb/resources/favicon/favicon.ico" type="image/x-icon">';
export const VIEWPORT_ELEMENT =
  '<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, shrink-to-fit=no">';
export const ADDITIONAL_META_ELEMENT = '<meta charset="utf-8">';
export const PATH_JQUERY =
  'https://page.kakaocdn.net/pageweb/resources/js/jQuery-1.11.0.js';
export const LEGACY_COMPATIBILITY_SCRIPT = `<script src="${PATH_JQUERY}"></script>`;
export const V3_EVENT_IFRAME_ID = 'v3-event-iframe';

export const AdditionallyExpectedApiStatusCodes = [
  ApiStatusCodeVo.EventNotFound,
  ApiStatusCodeVo.EventClosed,
];
